module.exports = __webpack_public_path__ + "img/calefaccion.95cf8658.svg";